module.exports = __webpack_public_path__ + "media/theme/JCS_New_Logo-f0e52216.png";